import React from 'react'
import s from './styles/GoogleLogin.module.scss'
import '../../../styles/buttons.scss'
import { ReactComponent as GoogleIcon } from '../../../../assets/icons/google_logo_color.svg'
import PositionedTooltip from 'shared/components/PositionedTooltip/PositionedTooltip'

export const GoogleLogin = ({
	loading,
	busy = false,
	onLogin,
	disabled = false,
	explanation = '',
}) => {
	const isDisabled = Boolean(loading || disabled)
	const showHint = Boolean(isDisabled && !busy && explanation)

	return (
		<div className={s.google}>
			<p className={s.title}>Or continue with google</p>

			<PositionedTooltip
				content={explanation}
				enabled={showHint}
				className={s.tooltipAnchor}
			>
				<button
					type="button"
					onClick={onLogin}
					disabled={isDisabled}
					aria-disabled={isDisabled}
					aria-busy={busy}
					className={`btn btn-light ${s.googleBtn} ${busy ? 'loading' : ''}`}
				>
					<span className={`btn__content ${busy ? 'btn__content--busy' : ''}`}>
						<span className="btn__icon">
							<GoogleIcon />
						</span>
						<span className="btn__text">Sign in with Google</span>
					</span>
					{busy ? <span className="btn__spinner" aria-hidden="true" /> : null}
				</button>
			</PositionedTooltip>
		</div>
	)
}
